import { NgModule } from '@angular/core';
import { BetonOrderCmsFormModule, BetonOrderCmsModalModule } from './cms-components';

@NgModule({
  imports: [BetonOrderCmsFormModule, BetonOrderCmsModalModule],
})
export class SdvorBetonUiModule {}
